import React, { useState } from "react";
import { LeftFootProfileImg } from "../../../assets";
import { IDiagnosis } from "../../../@types/diagnosis.interface";
import "./leftfeetProfile.style.css";

const LeftfeetProfile = ({ footcareAnalysis }: { footcareAnalysis: IDiagnosis }) => {
	const isOnReportPage = window.location.pathname.includes("/reports");
	const [activeDiagnosis, setActiveDiagnosis] = useState<{ painPoint: number } | null>(null);
	return (
		<div className="left-foot-profile">
			<div className="flex-row">
				<div className="image-container">
					<img
						src={LeftFootProfileImg}
						alt=""
						style={{ height: "100%", width: "100%" }}
						className="profile-img"
					/>
					<div className="arch-type">{footcareAnalysis.left_feet_arc_type}</div>
					{footcareAnalysis.left_feet_pain_point_list.includes(3) ? (
						<div
							className={`profile-3 profile-dot ${
								activeDiagnosis?.painPoint === 3 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
					{footcareAnalysis.left_feet_pain_point_list.includes(2) ? (
						<div
							className={`profile-2 profile-dot ${
								activeDiagnosis?.painPoint === 2 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
					{footcareAnalysis.left_feet_pain_point_list.includes(1) ? (
						<div
							className={`profile-1 profile-dot ${
								activeDiagnosis?.painPoint === 1 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
					{footcareAnalysis.left_feet_pain_point_list.includes(4) ? (
						<div
							className={`profile-4 profile-dot ${
								activeDiagnosis?.painPoint === 4 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
					{footcareAnalysis.left_feet_pain_point_list.includes(7) ? (
						<div
							className={`profile-7 profile-dot ${
								activeDiagnosis?.painPoint === 7 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
					{footcareAnalysis.left_feet_pain_point_list.includes(8) ? (
						<div
							className={`profile-8 profile-dot ${
								activeDiagnosis?.painPoint === 8 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
					{footcareAnalysis.left_feet_pain_point_list.includes(6) ? (
						<div
							className={`profile-6 profile-dot ${
								activeDiagnosis?.painPoint === 6 ? "pain-point-item-selected-profile" : ""
							}`}
						/>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default LeftfeetProfile;
